var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.2,
    height: 21.505,
    viewBox: "0 0 23.2 21.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "9.253 13.673 3.804 13.673 0.5 21.005 22.7 21.005 19.19 13.673 14.27 13.673",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.062,13.673a2.607,2.607,0,0,0,.581,2.513A4.616,4.616,0,0,0,9.016,17.7a11.3,11.3,0,0,0,2.829.36q.963.029,1.926.014a5.961,5.961,0,0,1,1.7.126,2.846,2.846,0,0,1,2.017,2.648",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.279,6.064A5.564,5.564,0,1,0,6.8,8.675h0l0,0c1.119,2.317,4.91,9.3,4.91,9.3s4.185-7.566,4.91-9.3l0,0h0A5.536,5.536,0,0,0,17.279,6.064ZM11.715,8.99a2.922,2.922,0,1,1,2.921-2.922A2.922,2.922,0,0,1,11.715,8.99Z",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.61c486cc52e64063ca5128eef1e9e660.svg";
export { ForwardRef as ReactComponent };